import React, {useEffect} from 'react';
import './alert.scss'

const BasicAlert = ({message, onClose, isOpen, isError = false}) => {
    useEffect(() => {
        if (!isOpen) {
            return
        }
        const id = setTimeout(() => {
            onClose()
        }, 3000)
        return () => {
            clearTimeout(id)
        }
    })

    return (
        <>
            {isOpen &&
                <div className={`${isError ? "errorAlert successAlert" : "successAlert" }`}>
                    <span className="successAlert-span">{message}</span>
                </div>

            }
        </>
    );
};

export default BasicAlert;